<template>
  <div>
    <a-layout>
      <a-layout style="background: #fff" v-if="selectMainMPK[0]">
        <a-layout-sider style="background: #fff">
          <h3>{{ $t("Main Company") }}</h3>
          <a-menu
            mode="inline"
            :default-selected-keys="selectMainMPK"
            @click="handleMenuClickItem"
          >
            <a-menu-item v-for="i in mainMPK" :key="i.ID">
              <span>{{ i.TITLE }}</span>
            </a-menu-item>
          </a-menu>
        </a-layout-sider>
        <a-layout-content style="background: #fff; padding-left: 20px">
          <h2
            style="text-align: center; margin-bottom: 1px"
            class="ant-col-xs-17 ant-col-offset-2"
          >
            {{ mainMPK.find((x) => x.ID == selectMainMPK[0])["TITLE"] }}
          </h2>

          <a-table
            :columns="columns"
            :data-source="dataSource"
            bordered
            :pagination="{ hideOnSinglePage: true }"
          >
            <template slot="footer">
              <a-row>
                <a-col :span="12" style="text-align: left">
                  <a-button class="editable-add-btn" @click="handleAdd">
                    <a-icon type="plus" />
                    {{ $t("Add") }}
                  </a-button>
                </a-col>
                <a-col :span="12" style="text-align: right">
                  <a-button type="primary" @click="handleSubmit">{{
                    $t("Save")
                  }}</a-button>
                </a-col>
              </a-row>
            </template>
            <template slot="MPK" slot-scope="text, record">
              <a-select
                v-if="record.editable"
                mode="tags"
                show-search
                style="margin: -5px 0; width: 100%"
                :default-value="text"
                option-filter-prop="children"
                :filter-option="filterOption"
                @change="(e) => handleChange(e, record.key, 'MPK')"
              >
                <a-select-option v-for="name in cacheMPKList" :key="name">{{
                  name
                }}</a-select-option>
              </a-select>
              <template v-else>
                <a-tag v-for="val in text" :key="val" color="blue">{{
                  val
                }}</a-tag>
              </template>
            </template>

            <template slot="numKonto" slot-scope="text, record">
              <a-input
                v-if="record.editable"
                style="margin: -5px 0"
                :value="text"
                @change="
                  (e) => handleChange(e.target.value, record.key, 'numKonto')
                "
              />
              <template v-else>{{ text }}</template>
            </template>

            <template slot="distributed" slot-scope="text, record">
              <a-switch
                v-if="record.editable"
                style="margin: -5px 0"
                :default-checked="text"
                @change="(e) => handleChange(e, record.key, 'distributed')"
              >
                <a-icon slot="checkedChildren" type="check" />
                <a-icon slot="unCheckedChildren" type="close" />
              </a-switch>
              <template
                v-else-if="typeof text == 'string' ? text == 'true' : text"
              >
                <a-icon
                  type="check-circle"
                  theme="twoTone"
                  two-tone-color="#52c41a"
                />&nbsp;{{$t('Tak')}}
              </template>
              <template v-else>
                <a-icon
                  type="close-circle"
                  theme="twoTone"
                  two-tone-color="#eb2f96"
                />&nbsp;{{$t('Nie')}}
              </template>
            </template>

            <template slot="CostTypes" slot-scope="text, record">
              <a-select
                v-if="record.editable"
                mode="multiple"
                show-search
                style="margin: -5px 0; width: 100%"
                :default-value="text"
                option-filter-prop="children"
                :filter-option="filterOption"
                @change="(e) => handleChange(e, record.key, 'CostTypes')"
              >
                <a-select-option v-for="name in CostTypesList" :key="name">{{
                  name
                }}</a-select-option>
              </a-select>
              <template v-else>
                <a-tag v-for="val in text" :key="val" color="green">{{
                  val
                }}</a-tag>
              </template>
            </template>

            <template slot="operation" slot-scope="text, record">
              <div class="editable-row-operations">
                <span v-if="record.editable">
                  <a @click="() => save(record.key)">
                    <a-icon type="save" />
                  </a>
                  <a
                    @click="() => cancel(record.key)"
                    style="margin-left: 10px"
                  >
                    <a-icon type="close" />
                  </a>
                </span>
                <span v-else>
                  <a
                    :disabled="editingKey !== ''"
                    @click="() => edit(record.key)"
                    style="margin-right: 20px"
                  >
                    <a-icon type="edit" />
                  </a>
                  <a
                    :disabled="editingKey !== ''"
                    @click="() => onDelete(record)"
                  >
                    <a-icon type="delete" />
                  </a>
                </span>
              </div>
            </template>
          </a-table>
        </a-layout-content>
      </a-layout>
    </a-layout>
    <a-divider orientation="left">
      {{ $t("Settings") }}
    </a-divider>

    <a-form
      id="settings_main_form"
      :form="form_main_cost"
      @submit="handleSubmit_main"
      :label-col="{
        xs: { span: 24 },
        sm: { span: 8 },
      }"
      labelAlign="left"
      :wrapper-col="{
        xs: { span: 24 },
        sm: { span: 12 },
      }"
    >
      <a-form-item :label="$t('Keywords')">
        <a-select
          :dropdownMatchSelectWidth="false"
          mode="tags"
          v-decorator="[
            'words',
            { rules: [{ required: false }], initialValue: user_val.words },
          ]"
        >
          <a-select-option v-for="i in user_val.words" :key="i">{{
            i
          }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item :label="$t('Specialization')">
        <a-select
          :dropdownMatchSelectWidth="false"
          mode="tags"
          v-decorator="[
            'SPECJALIZACJA',
            {
              rules: [{ required: false }],
              initialValue: user_val.SPECJALIZACJA,
            },
          ]"
        >
          <a-select-option v-for="i in user_val.SPECJALIZACJA" :key="i">{{
            i
          }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item :label="$t('List MPK')">
        <a-select
          :dropdownMatchSelectWidth="false"
          mode="tags"
          v-decorator="[
            'MPK',
            { rules: [{ required: false }], initialValue: user_val.MPK },
          ]"
        >
          <a-select-option v-for="i in user_val.MPK" :key="i">{{
            i
          }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item :label="$t('Cost types')">
        <a-select
          :dropdownMatchSelectWidth="false"
          mode="tags"
          v-decorator="[
            'CostTypes',
            {
              rules: [{ required: false }],
              initialValue: user_val.CostTypes,
            },
          ]"
        >
          <a-select-option v-for="i in user_val.CostTypes" :key="i">{{
            i
          }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item :label="$t('Rodzaj Przychodu')">
        <a-select
          :dropdownMatchSelectWidth="false"
          mode="tags"
          v-decorator="[
            'RodzajPrzychodu',
            {
              rules: [{ required: false }],
              initialValue: user_val.RodzajPrzychodu,
            },
          ]"
        >
          <a-select-option v-for="i in user_val.RodzajPrzychodu" :key="i">{{
            i
          }}</a-select-option>
        </a-select>
      </a-form-item>

    </a-form>
    <a-button slot="extra" type="primary" @click="handleSubmit_main">{{
      $t("Save")
    }}</a-button>
  </div>
</template>

<script>
import { saveSettings } from "@/requestFunc";
import { saveCostCenter } from "@/requestFunc";

export default {
  props: [
    "costCenter",
    "MPKList",
    "CostTypesList",
    "usernameList",
    "mainMPK",
    "user_val",
  ],
  data() {
    return {
      form_main_cost: this.$form.createForm(this, { name: "set_main_cost" }),
      cacheData: {},
      dataSource: [],
      cacheMPKList: [],
      editingKey: "",
      selectMainMPK: [],
      columns: [
        {
          title: this.$t("MPK"),
          dataIndex: "MPK",
          width: "15%",
          scopedSlots: { customRender: "MPK" },
        },
        {
          title: this.$t("Możliwość rozksięgowania"),
          dataIndex: "distributed",
          scopedSlots: { customRender: "distributed" },
        },
        {
          title: this.$t("Typy kosztow"),
          dataIndex: "CostTypes",
          scopedSlots: { customRender: "CostTypes" },
        },
        {
          title: this.$t("Operation"),
          dataIndex: "operation",
          width: 150,
          scopedSlots: { customRender: "operation" },
        },
      ]
    };
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    changeSpinning(val) {
      this.$emit("changeSpinning", val);
    },
    handleSubmit_main(e) {
      e.preventDefault();
      this.form_main_cost.validateFields((err, values) => {
        if (!err) {
          this.changeSpinning();
 
          saveSettings(values)
            .done((res) => {
              let vals = JSON.parse(res);
              this.$message.success(this.$t("Settings have been saved!"));
              this.$emit("updateFiles", {
                files: vals.all_file,
                settings: { ...values },
              });
            })
            .fail((e) => {
              console.error(e);
              this.$message.error(this.$t("Error"));
            })
            .always(() => {
              this.changeSpinning();
            });
        }
      });
    },
    handleMenuClickItem(e) {
      this.selectMainMPK = [e.key];
      if (!this.costCenter[e.key]) {
        this.costCenter[e.key] = { MPK_CostTypes: [] };
      }
      if (!this.costCenter[e.key]["MPK_CostTypes"]) {
        this.costCenter[e.key]["MPK_CostTypes"] = [];
      }
      if (Array.isArray(this.MPKList)) this.cacheMPKList = [...this.MPKList];
      this.dataSource = this.costCenter[e.key]["MPK_CostTypes"];
      for (let i of this.dataSource) {
        for (let j of i.MPK) {
          this.cacheMPKList.splice(
            this.cacheMPKList.findIndex((x) => x == j),
            1
          );
        }
      }
      this.cacheData = this.dataSource.map((item) => ({
        ...item,
      }));
    },
    handleSubmit() {
      this.costCenter[this.selectMainMPK[0]]["MPK_CostTypes"] = [
        ...this.dataSource,
      ];
      saveCostCenter(
        this.selectMainMPK[0],
        this.costCenter[this.selectMainMPK[0]]["MPK_CostTypes"]
      )
        .done(() => {
          this.$message.success(this.$t("Cost Center have been saved!"));
        })
        .fail((e) => {
          console.error(e);
          this.$message.error(this.$t("Error"));
        });
    },
    onDelete(record) {
      const newData = [...this.dataSource];
      if (record.MPK) {
        for (let i of record.MPK) {
          this.cacheMPKList.push(i);
        }
      }
      this.dataSource = newData.filter((item) => item.key !== record.key);
    },
    handleAdd() {
      for (let i in this.dataSource) {
        if (this.dataSource[i]["editable"]) {
          this.save(this.dataSource[i].key);
          break;
        }
      }
      const newData = {
        key: this.dataSource.length,
        MPK: [],
        numKonto: "",
        distributed: false,
        CostTypes: [],
        editable: true,
      };
      this.editingKey = newData.key;
      this.dataSource = [...this.dataSource, newData];

      this.cacheData = this.dataSource.map((item) => ({
        ...item,
      }));
    },
    handleChange(value, key, column) {
      const newData = [...this.dataSource];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.dataSource = newData;
      }
    },
    edit(key) {
      const newData = [...this.dataSource];
      const target = newData.filter((item) => key === item.key)[0];
      this.editingKey = key;
      if (target) {
        target.editable = true;
        this.dataSource = newData;
      }
    },
    save(key) {
      const newData = [...this.dataSource];
      const newCacheData = [...this.cacheData];
      const target = newData.filter((item) => key === item.key)[0];
      const targetCache = newCacheData.filter((item) => key === item.key)[0];
      if (target && targetCache) {
        delete target.editable;
        for (let i of target.MPK) {
          this.cacheMPKList.splice(
            this.cacheMPKList.findIndex((x) => x == i),
            1
          );
        }
        this.dataSource = newData;
        Object.assign(targetCache, target);
        this.cacheData = newCacheData;
      }
      this.editingKey = "";
    },
    cancel(key) {
      const newData = [...this.dataSource];
      const target = newData.filter((item) => key === item.key)[0];
      this.editingKey = "";
      if (target) {
        Object.assign(
          target,
          this.cacheData.filter((item) => key === item.key)[0]
        );
        delete target.editable;
        this.dataSource = newData;
      }
    },
  },
  mounted() {
    // console.log(this.user_val, 'user_val');
    if (Object.keys(this.mainMPK).length != 0) {
        this.handleMenuClickItem({ key: this.mainMPK[0]["ID"] });
    }
  },
};
</script>
<style>
.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
}
.dynamic-delete-button:hover {
  color: #777;
}
.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>